import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import { number, object, string } from "yup";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";
import { sanitizeValues } from "../../models/utils";

const initialValues = {
  id_compte: "",
  montant_ht: "",
  montant_ttc: "",
  texte_facture: "",
};

const validationSchema = object({
  id_compte: number().integer().required(),
  montant_ht: number().required(),
  montant_ttc: number().required(),
  texte_facture: string().required(),
});

export default function GenerateFactureForm({ onSubmit }) {
  const [error, setError] = useState("");

  async function submitHandler(values, { resetForm }) {
    try {
      setError("");
      await onSubmit(validationSchema.cast(sanitizeValues(values)));
      resetForm();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <>
      <p className={"cardTitle text-center marginB20"}>Générer une facture</p>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={submitHandler}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <TextInput name="id_compte" label={"ID du compte"} mandatory />
            <TextInput
              min={null}
              name="montant_ht"
              label={"Montant HT"}
              type={"number"}
              step={"0.01"}
              mandatory
              value={values.montant_ht}
              onChange={(e) => {
                const ht = e.target.value;
                setFieldValue("montant_ht", ht);
                setFieldValue(
                  "montant_ttc",
                  ht ? (parseFloat(ht) * 1.2).toFixed(2) : "",
                );
              }}
            />
            <TextInput
              min={null}
              name="montant_ttc"
              label={"Montant TTC"}
              type={"number"}
              step={"0.01"}
              mandatory
              value={values.montant_ttc}
              onChange={(e) => {
                const ttc = e.target.value;
                setFieldValue("montant_ttc", ttc);
                setFieldValue(
                  "montant_ht",
                  ttc ? (parseFloat(ttc) / 1.2).toFixed(2) : "",
                );
              }}
            />
            <TextInput
              type="text"
              name="texte_facture"
              label={"Texte de la facture"}
              mandatory
            />

            <FormikSubmitButton>Valider</FormikSubmitButton>
            <Callout variant="danger">{error}</Callout>
          </Form>
        )}
      </Formik>
    </>
  );
}
